import React from "react";
import { useLocation } from "react-router-dom";
import styles from "./HeroSection.module.css";

const titles = {
  "/about": "ABOUT US",
  "/menu": "MENU",
  "/events": "EVENTS",
  "/careers": "CAREERS",
};

const HeroSection = ({ backgroundImage }) => {
  const { pathname } = useLocation();
  const title = titles[pathname.toLowerCase()] || "ABOUT US";

  return (
    <section
      className={styles.hero}
      style={{
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      <div className={styles.overlay}></div>

      <div className={styles.content}>
        <h1>{title}</h1>
      </div>
    </section>
  );
};

export default HeroSection;
